<template>
	<div class="clock-mini">
		<div class="clock-container">
			<div class="clock-lg">
				{{ currentTime }}
			</div>
			<div class="clocks-small">
				<div class="clock-local">
					{{ time24h }}
				</div>
				<div class="clock-utc">
					{{ timeUtc }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let refreshInterval = null;
    
	export default {
		name: 'MiniClock',
		data() {
			return {
				currentTime: '',
				time24h: '',
				timeUtc: ''
			}
		},
		mounted() {
			console.log("Clock mini module initiated");
			this.updateTime();
			refreshInterval = setInterval(this.updateTime, 1000);
		},

		destroyed() {
			console.log("Stopping Clock mini module");
			clearInterval(refreshInterval);
		},
		
		methods: {
			updateTime() {
				let thisTime = moment();
				this.currentTime = thisTime.format("h:mm:ss A");
				this.time24h = thisTime.local().format("HH:mm z");
				this.time24h = thisTime.tz(window.localTimezone).format("HH:mm z");
				this.timeUtc = thisTime.utc().format("HH:mm") + " UTC";
			}
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	.clock-mini {
		height: 35%;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		align-items: center;
		padding-bottom: 8%;
		overflow: hidden;
		
		.clock-container {
			color: white;
			font-family: @font-main;
		}

		.clock-lg {
			text-align: center;
			font-size: 5.5em;
			font-weight: 700;
			line-height: 1em;
			width: 100%;
		}

		.clocks-small {
			display: flex;
			justify-content: space-between;
			width: 100%;
		}

		.clock-local {
			text-align: left;
			font-size: 1.8em;
			line-height: 1.4em;
		}

		.clock-utc {
			text-align: right;
			font-size: 1.8em;
			line-height: 1.4em;
		}
	}
</style>


// WEBPACK FOOTER //
// clock-mini.vue?3bc0fff8